import React from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { IntlShape, injectIntl } from 'react-intl'
import Step from '@src/components/AdvertisingCampaign/Form/Step'
import Textarea from '@iui-kit/components/Textarea'
import * as FIELD_NAMES from '@src/constants/AdvertisingBriefs/Search/fieldNames'
import { Formik } from '@src/types/BriefSearch/formikProps'

interface HOCProps {
  formik: Formik
  intl: IntlShape
}

const StepFive: React.FC<HOCProps> = (props: HOCProps) => {
  const {
    formik: { handleChange, handleBlur, values, errors, touched },
    intl: { formatMessage }
  } = props

  return (
    <Step title="Brief.search.step.five.title" notRequired={true}>
      <Textarea
        size="m"
        label="Brief.search.field.comment.label"
        name={FIELD_NAMES.COMMENT}
        onChange={handleChange}
        handleBlur={handleBlur}
        value={values[FIELD_NAMES.COMMENT]}
        isValid={!errors[FIELD_NAMES.COMMENT] || !touched[FIELD_NAMES.COMMENT]}
        placeholder={formatMessage({ id: 'Brief.search.field.comment.placeholder' })}
      />
    </Step>
  )
}

export default compose<React.FC>(connect, injectIntl)(StepFive)
